var map = {
	"./avatar-user.png": 520,
	"./background-breeding.png": 754,
	"./background-button-done.png": 745,
	"./background-checkin-popup.png": 755,
	"./background-checkin.png": 756,
	"./background-claim-gift.png": 757,
	"./background-create-new-scholarship.png": 551,
	"./background-gift.png": 1037,
	"./background-marketplace.png": 758,
	"./background-new-scholarship.png": 552,
	"./background-popup-gift.png": 1038,
	"./background-popup-redeem.png": 759,
	"./background-profile.png": 368,
	"./background-redeem.png": 760,
	"./background-register.png": 553,
	"./background-view-mobile.png": 746,
	"./background-view.png": 747,
	"./blank-square.png": 761,
	"./breeding-connect-left.png": 762,
	"./breeding-connect-right.png": 763,
	"./breeding-image-disable.png": 1039,
	"./breeding-image.png": 1040,
	"./button-feedback.png": 554,
	"./button-play-now.png": 555,
	"./bybit-text.png": 556,
	"./checkin-hero-left.png": 764,
	"./checkin-hero-right.png": 765,
	"./done-icon.png": 766,
	"./frame-avatar.png": 410,
	"./frame-board.png": 767,
	"./frame-breeding.png": 748,
	"./frame-card-chieftain.png": 411,
	"./frame-card-elder.png": 412,
	"./frame-card-grandchief.png": 413,
	"./frame-card-highchief.png": 414,
	"./frame-card-overseer.png": 415,
	"./frame-card-warchief.png": 416,
	"./frame-card-warlord.png": 417,
	"./frame-card-warmonger.png": 418,
	"./frame-card-warrior.png": 419,
	"./frame-chieftain.png": 768,
	"./frame-dialog.png": 769,
	"./frame-elder.png": 770,
	"./frame-grandchief.png": 771,
	"./frame-hero.png": 744,
	"./frame-highchief.png": 772,
	"./frame-market-hero.png": 420,
	"./frame-overseer.png": 773,
	"./frame-warchief.png": 774,
	"./frame-warlord.png": 775,
	"./frame-warmonger.png": 776,
	"./frame-warrior.png": 777,
	"./free-stamp.png": 1041,
	"./gold-bag-image.png": 778,
	"./gold.png": 749,
	"./hero-card.png": 521,
	"./image-button-explore.png": 522,
	"./info-icon.png": 779,
	"./loading-register.png": 1042,
	"./logo-faded.png": 780,
	"./logo-header.png": 370,
	"./market-cocoon-image.png": 781,
	"./market-hero-image.png": 782,
	"./new-cocoon.png": 783,
	"./no-item-conversation-bubble.png": 1043,
	"./no-item-image.png": 369,
	"./no-item-mobile-bubble.png": 1044,
	"./no-scholarship.png": 557,
	"./pancakeswap-text.png": 558,
	"./refer-steps.png": 1045,
	"./referral-banner-1.png": 559,
	"./rewards-bg.png": 1046,
	"./scholarship-header.png": 560,
	"./tokens-gift.png": 1047,
	"./trapezoid-tag.png": 544,
	"./union.png": 561,
	"./yellow-tripple-arrow.png": 562
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 421;